import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import Footer from "../../components/Footer/footer";
import HeaderComponent from "../../components/Header";
import "../../static/css/styles.css";
import { Spring } from "react-spring";
import CounsellorListCard from "./CounsellorListCard";
import { slotActions, authActions, counsellorActions } from "../../store/actions";
import Loading from "../../components/Loading/Loading";
import { history } from "../../helpers/history";
import { getCountryName } from "../../helpers/utils";
import { constants } from "../../Constants";
import downIcon from "../../static/images/down-icon.svg";
import { serviceTypeActions } from "../../store/actions/serviceType.actions";
import Swal from "sweetalert2";
import wellbeing from "../../static/images/wellbeing.svg"
import nutrionist from "../../static/images/nutrionist.svg"

class CounsellorList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countryName: null,
      serviceTypes: [],
      serviceTypeListTrigger: false,
      serviceTypeSelectedName:"",
      serviceTypeSelectedId: "",
      showCounselorList: true,
      serviceDropDown: [],
      isAlreadyInRelation: false
    };
    this.createAppointment = this.createAppointment.bind(this);
  }

  createAppointment(counsellor_id) {
    history.push(`/create_appointment/${counsellor_id}`);
  }

  handleServiceTypeChange = (type) => {

    this.setState({
      serviceTypeSelectedName: type.name,
      serviceTypeSelectedId: type.code,
    });


    if (!type.is_active) {
      this.setState({ showCounselorList: false });
      Swal.fire({
        titleText: constants.SUBSCRIPTION_TXT,
        html: constants.SERVICE_NOT_SUBSCRIBED_MESSAGE(type.name).replace(
          'contact@saayahealth.com', 
          '<a href="mailto:contact@saayahealth.com">contact@saayahealth.com</a>'
        ),
      });           
    } else {
      let alreadyInRelation = false
      this.props.multiCounsellor && this.props.multiCounsellor.length && this.props.multiCounsellor.forEach(serviceType => {
        if (serviceType.service_type.code === type.code){
          alreadyInRelation = true
          this.setState({ isAlreadyInRelation: true})
        }
      })
      this.setState({showCounselorList: !alreadyInRelation, isAlreadyInRelation: alreadyInRelation})
    }
  };
  // Get country name
  getCountryDetails = async () => {
    let subsidiary = this.props.user && this.props.user.subsidiary && this.props.user.subsidiary.toLowerCase();
    this.setState({ countryName: await subsidiary });
  };

  componentDidMount() {
    const language = localStorage.getItem('language');
    this.props.getUserData();
    this.props.fetchCounsellorList(language);
    this.props.fetchServiceType();
    this.props.getMultiCounsellor()
    if (!this.state.countryName) this.getCountryDetails();
  }

  componentWillReceiveProps(nextProps){
    const {user } = nextProps
    const {serviceTypes} = nextProps.state
    let changeHandlerCalledOnce = false
    let dropDown = [];
    if (
      user &&
      serviceTypes.service_types &&
      serviceTypes.service_types.length > 0
    ) {
      dropDown = serviceTypes.service_types.map((item1) => {

        let isServiceTypeActive = user.projects[0].project_service_types.some(
          (item2) => item2.service_type.code === item1.code
        );
        let checkSelectedFromHome =  localStorage.getItem("selected_type")
        if (!changeHandlerCalledOnce && checkSelectedFromHome === item1.code && dropDown.length === 0 && isServiceTypeActive){
          this.handleServiceTypeChange(item1)
          changeHandlerCalledOnce = true
          localStorage.removeItem("selected_type")
        } else if (!changeHandlerCalledOnce && !this.state.serviceTypeSelectedName && isServiceTypeActive && dropDown.length === 0){
          this.handleServiceTypeChange(item1)
          changeHandlerCalledOnce = true
        }
        return {
          ...item1,
          is_active: isServiceTypeActive,
        };
      });
      this.setState({serviceDropDown: dropDown})
    }
  }

  render() {
    const { whitelabel } = this.props;
    const { slots } = this.props.state;

    let dropDown = this.state.serviceDropDown
    let counselorsList = [];
    this.state.showCounselorList &&
      slots.list &&
      slots.list.length > 0 &&
      slots.list.forEach((list) => {
        list.service_type.code === this.state.serviceTypeSelectedId &&
          counselorsList.push(list);
      });
    return (
      <div className="sh-layout">
        <HeaderComponent />
        <div className="sh-counsellor-list-comp sh-gnrl-width">
          {/* Welcome Note */}
          <div className="sh-gnrl-welcome-note">
            <h2 className="sh-gnrl-welcome" id="">
              {"CHOOSE YOUR COUNSELLOR"}
            </h2>
          </div>

          {whitelabel && whitelabel[0].name.toLowerCase() !== 'cwp' && <React.Fragment>
            <div className="text-align-center mb10">
              <div
                class="dropdown"
                onClick={() => {
                  this.setState({
                    serviceTypeListTrigger: !this.state.serviceTypeListTrigger,
                  });
                }}
              >
                <button class="dropbtn">
                  <Fragment>
                    <span style={{ color: "#565656" }}>
                      {this.state.serviceTypeSelectedName ||
                        constants.SELECT_SERVICE_TYPE_TXT}
                    </span>
                    <img
                      width="20px"
                      style={{
                        textAlign: "right",
                        verticalAlign: "unset",
                        right: "10px",
                        position: "absolute",
                        paddingTop: "5px",
                      }}
                      height="15px"
                      src={downIcon}
                      alt=""
                    />
                  </Fragment>
                </button>
                <div
                  class="dropdown-content"
                  style={{
                    display: this.state.serviceTypeListTrigger
                      ? "block"
                      : "none",
                  }}
                  onBlur={() => {
                    this.setState({
                      languageListTrigger: !this.state.serviceTypeListTrigger,
                    });
                  }}
                >
                  {dropDown.length > 0 &&
                    dropDown.map((type) => (
                      <a
                        href={(e) => {
                          return false;
                        }}
                        onClick={() => this.handleServiceTypeChange(type)}
                      >

                        <img
                          src={type.name.toLowerCase() === 'wellbeing' ? wellbeing : nutrionist}
                          alt=""
                          width="20px"
                          height="15px"
                        />
                        {" "}
                        {type.name}
                      </a>
                    ))}
                </div>
              </div>
            </div>
          </React.Fragment>}

          <div className="sh-counsellor-list">
            <div className="inner-list">
              {this.props.state.slots.list ? (
                counselorsList.length > 0 ? (
                  counselorsList.map((v, i) => {
                    return (
                      <div className="grid-col">
                        <CounsellorListCard
                          countryNameState={
                            this.state.countryName && this.state.countryName
                          }
                          whitelabel={whitelabel && whitelabel[0]}
                          v={v}
                          id={i}
                          key={i}
                          createAppointment={() =>
                            this.createAppointment(v.counsellor_id)
                          }
                        />
                      </div>
                    );
                  })
                ) : (
                  <React.Fragment>
                    <div className="grid-col"></div>
                    <div className="grid-col" style={{ textAlign: "center" }}>
                      {this.state.showCounselorList
                        ? `No
                      ${
                        whitelabel && whitelabel[0]
                          ? whitelabel[0].producer_role.toLowerCase()
                          : constants.COUNSELLOR.toLowerCase()
                        } 
                      available for now`
                        : this.state.isAlreadyInRelation ? constants.ACTIVE_RELATIONSHIP_MESSAGE
                          :
                          <div>
                          {constants.SERVICE_NOT_SUBSCRIBED_MESSAGE(this.state.serviceTypeSelectedName).split('contact@saayahealth.com')[0]}
                          <a href="mailto:contact@saayahealth.com">contact@saayahealth.com</a>
                          {constants.SERVICE_NOT_SUBSCRIBED_MESSAGE(this.state.serviceTypeSelectedName).split('contact@saayahealth.com')[1]}
                        </div>
                        
                      }
                    </div>
                  </React.Fragment>
                )
              ) : (
                <Loading />
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {counsellorStatus} = state
  const { authstate, user } = state.auth;
  const { whitelabel } = state.whitelabel;
  return {
    alert,
    authstate,
    whitelabel,
    user,
    state,
    multiCounsellor: counsellorStatus.multiCounsellor
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchCounsellorList: (language) => {
      dispatch(slotActions.fetchCounsellorList(language));
    },
    getUserData: () => {
      dispatch(authActions.getUserData());
    },
    fetchServiceType: () => {
      dispatch(serviceTypeActions.fetchServiceType());
    },
    getMultiCounsellor: () => {
      dispatch(
        counsellorActions.getMultiCounsellor()
      );
    },
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CounsellorList)
);



// WEBPACK FOOTER //
// ./src/screens/CounsellorList/index.js